import { render } from "./track.vue?vue&type=template&id=476c5d32"
import script from "./track.vue?vue&type=script&lang=js"
export * from "./track.vue?vue&type=script&lang=js"

import exportComponent from "D:\\html\\bracelet-management-system\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__